<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-toolbar dark color="primary pl-2 pr-2" dense>
        <v-toolbar-title>User Profile</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$emit('exist')">
          <v-icon>cancel</v-icon>
        </v-btn>
      </v-toolbar>
    </v-col>
    <v-col>
          <online-shopping/>
    </v-col>
    </v-row>
</template>
<script>
import OnlineShopping from '../views/OnlineShopping.vue';
export default {
  data: () => ({
    
  }),
   props: {},
  mounted: function() {},
  methods: {},
  watch: {},
  components: {OnlineShopping}
};
</script>
<style scoped>
.information-window
    OnlineShopping-v-sheet {
  height: 100vh !important;
  overflow-x: scroll;
}
</style>